/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssetClass = {
    BOND: 'Bond',
    EQUITY: 'Equity',
    OPTIONS: 'Options',
    FUTURES: 'Futures',
    OTHER: 'Other'
} as const;
export type AssetClass = typeof AssetClass[keyof typeof AssetClass];


export function instanceOfAssetClass(value: any): boolean {
    for (const key in AssetClass) {
        if (Object.prototype.hasOwnProperty.call(AssetClass, key)) {
            if (AssetClass[key as keyof typeof AssetClass] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssetClassFromJSON(json: any): AssetClass {
    return AssetClassFromJSONTyped(json, false);
}

export function AssetClassFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetClass {
    return json as AssetClass;
}

export function AssetClassToJSON(value?: AssetClass | null): any {
    return value as any;
}

export function AssetClassToJSONTyped(value: any, ignoreDiscriminator: boolean): AssetClass {
    return value as AssetClass;
}

